import { __makeTemplateObject } from "tslib";
import styled from "styled-components";
export var TakeatLogoContainer = styled.svg(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  path {\n    fill: ", ";\n  }\n"], ["\n  path {\n    fill: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme, color = _a.color, customColor = _a.customColor;
    return customColor || theme.colors[color].default;
});
var templateObject_1;
//# sourceMappingURL=styles.js.map